import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { SplitElements } from './SplitElements';

export const PaymentMethodForm = ({ stripe, submitBtnText, handleClose, handleCreateSuccess }) => {
  return (
    <Elements stripe={stripe}>
      <SplitElements
        submitBtnText={submitBtnText}
        handleClose={handleClose}
        handleCreateSuccess={handleCreateSuccess}
      />
    </Elements>
  );
};
